import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { BaseComponent } from '../../base.component';
/* tslint:disable:template-cyclomatic-complexity */
var LayerCatalogItemComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerCatalogItemComponent, _super);
    function LayerCatalogItemComponent(_vcr, layerService, cdr, toSqlStringService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.cdr = cdr;
        _this.toSqlStringService = toSqlStringService;
        _this.closeWindowEvent = new EventEmitter();
        _this.checkChangedEvent = new EventEmitter();
        _this.detailsExpanded = false;
        _this.layerData = null;
        _this.loading = false;
        _this.error = false;
        return _this;
    }
    Object.defineProperty(LayerCatalogItemComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerCatalogItemComponent.prototype, "includeEsriCss", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerCatalogItemComponent.prototype, "includeOverrideCss", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    LayerCatalogItemComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        if (!this.mapViewRef) return [3 /*break*/, 1];
                        _b = this.mapViewRef;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.mapViewRef = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogItemComponent.prototype.toggle = function () {
        this.layerCatalogItem.expanded = !this.layerCatalogItem.expanded;
        if (this.layerCatalogItem.layer) {
            this.toggleDetails();
        }
    };
    LayerCatalogItemComponent.prototype.toggleDetails = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.layerCatalogItem.ispetl) return [3 /*break*/, 3];
                        this.detailsExpanded = !this.detailsExpanded;
                        if (!(!this.layerData && this.layerCatalogItem.layer)) return [3 /*break*/, 3];
                        if (!(this.layerItemType === 'External')) return [3 /*break*/, 1];
                        this.layerData = this.layerCatalogItem.layer;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getLayerData()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogItemComponent.prototype.itemSelectedChanged = function () {
        this.checkChangedEvent.emit({ name: this.layerCatalogItem.name, isSelected: this.layerCatalogItem.isSelected });
    };
    LayerCatalogItemComponent.prototype.checkChanged = function () {
        this.checkChangedEvent.emit(this.layerCatalogItem);
    };
    LayerCatalogItemComponent.prototype.getLayerData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerId, props, data, query, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.error = false;
                        this.loading = true;
                        layerId = this.layerCatalogItem.layer.id;
                        props = 'columns {name, databaseDataType, databaseDataLength} name description featureEndpoints{url} lastEditedDate queryJSON recordCount maximumRecordUpdateDate hoverColumnList tables{id geometryType name owner }';
                        this.cdr.detectChanges();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.layerService.getLayersFromApi([layerId], props)];
                    case 2:
                        data = _a.sent();
                        this.layerData = data[0];
                        query = {};
                        if (this.layerData.queryJSON && this.layerData.queryJSON !== 'null') {
                            query = JSON.parse(this.layerData.queryJSON);
                        }
                        if (!this.layerData.maximumRecordUpdateDate) {
                            this.layerData.maximumRecordUpdateDate = 'Unknown';
                        }
                        this.layerData.sql = this.toSqlStringService.getSql(query, this.layerData.columns, this.layerData.tables.sort(function (a, b) { return a.geometryType.localeCompare(b.geometryType); })[0]);
                        this.layerData.tableNames = this.layerData.tables ? this.layerData.tables.map(function (t) { return t.name; }) : this.layerData.tableNames;
                        this.cdr.detectChanges();
                        this.loading = false;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.error = true;
                        throw err_1;
                    case 4:
                        this.cdr.detectChanges();
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return LayerCatalogItemComponent;
}(BaseComponent));
export { LayerCatalogItemComponent };
